import moment from "moment";
// import React from "react";

var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
export const convertStringToDate = ({ format, dateParam }) => {
  if (format === "dmy") {
    // for report or overview
    let newDate = null;
    if (
      dateParam &&
      dateParam != "0000-00-00" &&
      dateParam != "" &&
      dateParam != null &&
      dateParam != "null" &&
      dateParam != "Null" &&
      dateParam != "NULL"
    ) {
      newDate = moment(dateParam).format("DD MMMM YYYY");
    } else {
      newDate = null;
    }
    return newDate;
  } else if (format === "withId") {
    // for with id call to populate date to the date picker field
    let newDate = null;
    if (
      dateParam &&
      dateParam != "0000-00-00" &&
      dateParam != "" &&
      dateParam != null &&
      dateParam != "null" &&
      dateParam != "Null" &&
      dateParam != "NULL"
    ) {
      newDate = new Date(dateParam);
    } else {
      newDate = null;
    }
    return newDate;
  }
};

export const Tax_type_Lov = ({
  cell,
  row,
  enumObject,
  index,
  overview,
  field,
  decimal,
  companySymbol,
}) => {
  //   return;
  const taxTypeLov = [
    { id: "e", value: "e", label: "Exclusive" },
    { id: "i", value: "i", label: "Inclusive" },
  ];
  if (overview) return taxTypeLov;
};
export const dynamicCurrencyFormator = ({
  cell,
  row,
  enumObject,
  index,
  overview,
  field,
  decimal,
  companySymbol,
}) => {
  //   return;
  let newCell = "";
  if (cell !== 0 && cell !== "0" && cell !== "-" && cell !== null) {
    if (typeof cell === "string") {
      cell = parseFloat(cell);
    }

    if (decimal) {
      newCell = cell?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    } else {
      newCell = cell?.toLocaleString("en-US", {});
    }
    if (companySymbol) newCell = companySymbolCurrency + " " + newCell;
  } else {
    if (field) {
      newCell = 0;
    } else newCell = "-";
  }
  if (overview) return newCell;
  else if (field) return newCell;
};
export const dynamicPercentageToAmount = ({ totalnet, amount, percentage }) => {
  console.log("checccccck", totalnet, amount, percentage);
  //   return;
  let newAmount = "";
  if (amount) return (newAmount = ((amount / totalnet) * 100).toFixed(2));
  console.log("newAmount", newAmount, percentage);
};
export const roundDecimalNumber = ({ number, decimal }) => {
  let newNumber = number;
  if (typeof number === "string") newNumber = parseFloat(newNumber);
  return parseFloat(newNumber.toFixed(decimal));
};
export const creditDebitFormator = ({ cell, type }) => {
  let newCell = "";
  let dynamicSign = "";
  newCell = cell;

  if (cell && typeof cell === "string") {
    newCell = parseFloat(cell);
  }
  if (type && cell) {
    dynamicSign = newCell > 0 ? " Dr" : " Cr";
    newCell = newCell ? Math.abs(newCell) : newCell;
  }
  if (newCell) {
    newCell = newCell?.toLocaleString("en-US", {
      // maximumFractionDigits: 2,
      // minimumFractionDigits: 2,
    });

    // newCell = companySymbolCurrency + " " + newCell;
  } else {
    newCell = "-";
  }
  console.log(newCell);
  if (type && newCell !== "-") {
    newCell = newCell + dynamicSign;
  }
  console.log("from functions", newCell);
  return newCell;
};
export const convertStringToNumber = (input) => {
  // Check if input is undefined or null
  if (input === undefined || input === null) {
    console.error("Input is not defined or is null");
    return 0;
  }

  // Convert input to string if it's not already a string
  const str = typeof input === "string" ? input : String(input);

  // Normalize the string
  const normalizedStr = str.replace(/,/g, "").replace(/ /g, "");

  // Convert to number
  const num = Number(normalizedStr);

  // Check if the conversion result is NaN
  if (isNaN(num)) {
    console.error("Input cannot be converted to a valid number");
    return 0;
  }

  return num;
};

// Does this supplier belong to one of the branch's supplier types (Supplier
// Branch Mapping)? `branch` is a row from /lovs/getDynamicBranchLov, which
// carries supp_categ_ids -- one type for most clients, possibly several for
// the clients allowed multi-type branches (MULTI_SUPP_TYPE_PER_BRANCH_DBS on
// the backend). A branch with no mapping, or a branch object that predates
// supp_categ_ids, falls back to the original single-value comparison, so
// behaviour is unchanged wherever a branch has at most one type.
export const supplierMatchesBranch = (supplier, branch) => {
  const ids = branch?.supp_categ_ids;
  if (!Array.isArray(ids) || ids.length === 0) {
    return supplier?.supp_categ_id === branch?.supp_categ_id;
  }
  return ids.includes(supplier?.supp_categ_id);
};
// module.exports = {
//   convertStringToDate,
// };
